import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import DivDiagonal from "../../components/DivDiagonal";
import {
    TradingWrapper,
    ContentArea,
    TradingListPageHeader,
    TradingCard,
} from "../Trading/styles";

const PageStretch = styled.div`
    width: 100%;
    align-self: flex-start;
    flex: 1 1 auto;
`;

const PolicyNarrow = styled.div`
    max-width: 820px;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    position: relative;
    z-index: 2;
`;

const PolicyCard = styled(TradingCard)`
    padding: 24px 22px 28px;

    @media (min-width: 768px) {
        padding: 32px 36px 36px;
    }
`;

const PolicyIntro = styled.p`
    color: rgba(255, 255, 255, 0.88);
    font-size: 15px;
    line-height: 1.65;
    margin: 0 0 24px;
`;

const PolicySection = styled.section`
    margin-bottom: 22px;

    &:last-of-type {
        margin-bottom: 0;
    }
`;

const PolicySectionTitle = styled.h2`
    color: #f29205;
    font-size: 17px;
    font-weight: 700;
    margin: 0 0 12px;
    text-shadow: 0 0 10px rgba(242, 146, 5, 0.2);

    @media (min-width: 768px) {
        font-size: 18px;
    }
`;

const PolicyList = styled.ul`
    margin: 0;
    padding-left: 1.25rem;
    color: rgba(255, 255, 255, 0.82);
    font-size: 14px;
    line-height: 1.6;

    li + li {
        margin-top: 10px;
    }
`;

const PolicyMeta = styled.p`
    color: rgba(255, 255, 255, 0.55);
    font-size: 14px;
    margin: 0 0 20px;
`;

const BackLink = styled(Link)`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-top: 24px;
    color: #f29205 !important;
    font-weight: 600;
    font-size: 14px;
    text-decoration: none !important;
    transition: opacity 0.2s ease;

    &:hover {
        opacity: 0.9;
        color: #ffb347 !important;
    }
`;

export default function PolicyPrivacy() {
    const { t } = useTranslation();

    return (
        <PageStretch>
            <TradingWrapper>
                <DivDiagonal />
                <ContentArea>
                    <TradingListPageHeader>
                        <h1>
                            <i className="fas fa-shield-alt" aria-hidden="true"/> {t('policy_privacy_page_h1')}
                        </h1>
                    </TradingListPageHeader>

                    <PolicyNarrow>
                        <PolicyCard>
                            <PolicyMeta>{t('policy_privacy_meta')}</PolicyMeta>

                            <PolicyIntro>{t('policy_privacy_intro')}</PolicyIntro>

                            <PolicySection>
                                <PolicySectionTitle>{t('policy_privacy_section_collect')}</PolicySectionTitle>
                                <PolicyList>
                                    <li>{t('policy_privacy_collect_1')}</li>
                                    <li>{t('policy_privacy_collect_2')}</li>
                                </PolicyList>
                            </PolicySection>

                            <PolicySection>
                                <PolicySectionTitle>{t('policy_privacy_section_use')}</PolicySectionTitle>
                                <PolicyList>
                                    <li>{t('policy_privacy_use_1')}</li>
                                    <li>{t('policy_privacy_use_2')}</li>
                                </PolicyList>
                            </PolicySection>

                            <PolicySection>
                                <PolicySectionTitle>{t('policy_privacy_section_share')}</PolicySectionTitle>
                                <PolicyList>
                                    <li>{t('policy_privacy_share_1')}</li>
                                    <li>{t('policy_privacy_share_2')}</li>
                                </PolicyList>
                            </PolicySection>

                            <PolicySection>
                                <PolicySectionTitle>{t('policy_privacy_section_security')}</PolicySectionTitle>
                                <PolicyList>
                                    <li>{t('policy_privacy_security_1')}</li>
                                    <li>{t('policy_privacy_security_2')}</li>
                                    <li>{t('policy_privacy_security_3')}</li>
                                </PolicyList>
                            </PolicySection>

                            <PolicySection>
                                <PolicySectionTitle>{t('policy_privacy_section_changes')}</PolicySectionTitle>
                                <PolicyList>
                                    <li>{t('policy_privacy_changes_1')}</li>
                                </PolicyList>
                            </PolicySection>

                            <PolicySection>
                                <PolicySectionTitle>{t('policy_privacy_section_contact')}</PolicySectionTitle>
                                <PolicyList>
                                    <li>{t('policy_privacy_contact_1')}</li>
                                </PolicyList>
                            </PolicySection>

                            <PolicySection>
                                <PolicySectionTitle>{t('policy_privacy_section_third')}</PolicySectionTitle>
                                <PolicyIntro as="p" style={{ marginBottom: 0 }}>
                                    {t('policy_privacy_third_1')}
                                </PolicyIntro>
                            </PolicySection>

                            <BackLink to="/">
                                <i className="fas fa-arrow-left" aria-hidden="true"/>
                                {t('policy_privacy_back')}
                            </BackLink>
                        </PolicyCard>
                    </PolicyNarrow>
                </ContentArea>
            </TradingWrapper>
        </PageStretch>
    );
}
